import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface QuizState {
  quiz: Record<any, any>;
}

const initialState: QuizState = {
  quiz: {},
};

export const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    setQuiz: (state, action: PayloadAction<Record<string, any>>) => {
      state.quiz = action.payload;
    },
  },
});

export const { setQuiz } = quizSlice.actions;
export default quizSlice.reducer;
